import clsxm from "utils/clsxm"
import Typography from "../../typography"

interface CardTitleProps {
  as?: React.ElementType
  className?: string
  children: React.ReactNode
}

const CardTitle = ({ as, children, className }: CardTitleProps) => {
  return (
    <Typography
      as={as ?? "h3"}
      variant="text3"
      className={clsxm("font-bold", className)}
    >
      {children}
    </Typography>
  )
}

export default CardTitle
